<template>
  <div class="page about-page">
    <header class="page-header">
      <h1>关于我们</h1>
      <p class="tagline">连接每一位机器人与具身智能开发者。</p>
      <p>鱼香ROS(杭州鱼香机器人科技有限公司旗下品牌)，是机器人与具身智能开发者教育及生态平台，专注于机器人开发生态，提供硬件、系统与配置能力的完整解决方案。</p>
    </header>
    <div class="info-grid">
      <div class="info-card" v-for="item in info" :key="item.title">
        <h3>{{ item.title }}</h3>
        <p>{{ item.desc }}</p>
      </div>
    </div>
    <section class="contact">
      <h2>联系我们</h2>
      <div class="contact-grid">
        <div>
          <strong>公司名称</strong>
          <p>杭州鱼香机器人科技有限公司</p>
        </div>
        <div>
          <strong>官网地址</strong>
          <p>https://fishros.com</p>
        </div>
        <div>
          <strong>邮箱</strong>
          <p>fishros@163.com</p>
        </div>
        <div>
          <strong>微信公众号</strong>
          <p>鱼香ROS</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      info: [
        { title: '品牌定位', desc: '机器人与具身智能开发者教育及生态平台' },
        { title: '使命', desc: '降低机器人与具身智能学习、开发和应用的门槛。' },
        { title: '愿景', desc: '成为具身智能时代领先的开发者教育与生态平台' },
        { title: '能力', desc: '硬件、系统、配置助手与应用落地。' }
      ]
    }
  }
}
</script>

<style scoped>
.page {
  width: 88%;
  max-width: 1280px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.page-header {
  background: #fff;
  padding: 24px 28px;
  border-radius: 12px;
  margin-bottom: 24px;
}
.page-header h1 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.page-header p {
  margin: 0;
  color: #666;
}
.page-header .tagline {
  margin: 0 0 8px;
  color: #e11d48;
  font-weight: 600;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.info-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid #ececec;
}
.info-card h3 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.info-card p {
  margin: 0;
  color: #666;
}
.contact {
  background: #fff;
  border-radius: 12px;
  padding: 24px 28px;
}
.contact h2 {
  margin: 0 0 12px;
  color: #1f2b5b;
}
.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  color: #555;
}
.contact-grid p {
  margin: 4px 0 0;
}
@media screen and (max-width: 768px) {
  .page {
    width: 90%;
  }
}
</style>
